// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateInitialLoad = () => false;

export default (state = getDefaultState().isInitialLoad, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_CLAIM_FILTERED]: updateInitialLoad
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/reducers/initial-load.js